import React, { Component } from 'react'
import WhitePanel from '../../../UI/white-panel/whitePanel'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import {
  fetchData,
  setCurrentPlaylist,setCurrentSong , isPlayingInBackground
} from '../../../action/musicAction'
import defaultImagePic from '../../../images/default_cover_music.png'
import { musicPlayListColor } from '../../../JS/setColors'
import { CMSPath } from "../../../config/constant";
import {
  setGoHome
} from "../../../layout2.0/action/homeAction";
import ConfirmaionPopup from '../../../layout2.0/UI/warningConfirmationPopup'
import MiniLoader from '../../../layout2.0/UI/MiniLoader';


class PlayList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noImage: [],
      OnbackPopup: false,
      initalLoader: true
    }
  }
  clickOnGenre = (selectedPlaylist) => {
    this.props.handleGoNext(selectedPlaylist);
  }
  imageNotfound = (id) => {
    let noImageA = [...this.state.noImage];
    noImageA.push(id);
    //console.log("image not found.", noImageA);
    this.setState({ noImage: noImageA })
  }

  componentDidMount() {
    musicPlayListColor(this.props.menuColor);

    if(this.props.genres.length == 0){
      this.setState({initalLoader: true});

      setTimeout(() => {
        this.setState({initalLoader: false});
      }, 10000);
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.genres != this.props.genres && this.props.genres.length > 0){
      this.setState({initalLoader: false});
    }
  }

  render() {
    return (
      <>
        <div className="music-player" >
          <div className="music-title" >Music Playlist</div>
          <div className="playlist thumb-playlist">
            <div className="playlist-container">
              {
                this.props.genres.length > 0 ?
                  this.props.genres.map((iterator) => (
                    <div
                      key={iterator.id}
                      className="music-row"
                      data-target="loadList"
                      onClick={() => this.clickOnGenre(iterator)}
                    >
                      <div
                        className="music-thumb"
                        style={
                          iterator.genreImage && this.state.noImage.indexOf(iterator.id) === -1
                            ? {
                              background: `url('${this.props.imageBaseUrl}${iterator.genreImage}') center center no-repeat`,
                              backgroundSize: "cover"
                            }
                            : {
                              background: `url('${defaultImagePic}') center center no-repeat`,
                              backgroundSize: "cover"
                            }
                        }
                      >
                        {/* Hidden img tag to check if image URL is valid */}
                        <img
                          style={{ display: "none" }}
                          src={`${this.props.imageBaseUrl}${iterator.genreImage}`}
                          onError={() => this.imageNotfound(iterator.id)}
                          alt="genre thumbnail"
                        />
                      </div>
                      <div className="music-name">{iterator.genreName}</div>
                    </div>
                  ))
                  : this.state.initalLoader ? <MiniLoader /> : <div className="music-player"> <h1>No Music available at this moment</h1></div>
              }
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    genres: state.store.music.musicGenres.genres,
    stringConst: state.store.home.stringConst,
    imageBaseUrl: state.store.music.musicGenres.imageBaseUrl,
    menuColor: state.store.home.MenuColor,
    currentSong: state.store.music.currentSong,
    isPlayingInBackground: state.store.music.isPlayingInBackground,
    logo: state.store.home.currentDuration.brandingInfo ?
    state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
  }
}

export default connect(
  mapStateToProps,
  {
    fetchData,
    setCurrentPlaylist,
    setGoHome,
    setCurrentSong,
    isPlayingInBackground
  }
)(PlayList);